import styled from 'styled-components';

export const Wrapper = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  gap: size.units(3),
  alignItems: 'center',
}));
